import { IconArrowRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Card, Text } from '@fragments';
import { CommunityBanner } from '@components/Community';

import './styles.scss';

const ROLE_KEYS = { owner: 'owner', admin: 'admin', member: 'member' };

/**
 * CommunityMiniCard — the small side-by-side community card that replaces the
 * story circles: logo, name, the user's role, and a trailing arrow that nudges
 * on hover. The whole card is the target.
 */
export default function CommunityMiniCard({ community, index = 0, onOpen }) {
    const { t } = useTranslation('member');

    const roleKey = ROLE_KEYS[community.role] || 'member';
    const canOpen = !!community.slug;

    return (
        <Card
            flat
            noBodyPadding
            interactive={canOpen}
            className="community-mini"
            style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
            onClick={canOpen ? () => onOpen(community) : undefined}
            aria-label={canOpen ? t('publicProfile.communities.open', { name: community.name }) : community.name}
        >
            <div className="community-mini__row">
                <CommunityBanner banner={community.banner} size={44} className="community-mini__logo" />

                <div className="community-mini__copy">
                    <Text.label contrast={9} maxLines={1}>{community.name}</Text.label>
                    <Text.caption contrast={6}>{t(`publicProfile.roles.${roleKey}`)}</Text.caption>
                </div>

                {canOpen && <IconArrowRight className="community-mini__arrow" aria-hidden="true" />}
            </div>
        </Card>
    );
}
